<template>
	<div id="modal-orders-sales-orders-edit-shipping">
		<b-modal :id="modalName" title="Edit Product: " scrollable hide-footer>
            <template v-slot:modal-title>
                Edit Shipping Address:
            </template>

            <b-form v-if="shippingAddress" @submit.stop.prevent="updateAddress">
                <b-form-group
                    id="input-group-address-1"
                    label="Address 1:"
                    label-for="input-address-1"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-address-1"
                        v-model="shippingAddress.shipping_address_1"
                        type="text"
                        placeholder=""
                        size="sm"
                        autocomplete="off"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-address-2"
                    label="Address 2:"
                    label-for="input-address-2"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-address-2"
                        v-model="shippingAddress.shipping_address_2"
                        type="text"
                        placeholder=""
                        size="sm"
                        autocomplete="off"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="input-group-city"
                            label="City:"
                            label-for="input-city"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-city"
                                v-model="shippingAddress.shipping_city"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-state"
                            label="State:"
                            label-for="input-state"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-state"
                                v-model="shippingAddress.shipping_state"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-zip"
                            label="Zip:"
                            label-for="input-zip"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-zip"
                                v-model="shippingAddress.shipping_postal_code"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-group
                    id="input-group-country"
                    label="Country:"
                    label-for="input-country"
                    label-size="sm"
                >
                    <b-form-input
                        id="input-country"
                        v-model="shippingAddress.shipping_country"
                        type="text"
                        placeholder=""
                        size="sm"
                        autocomplete="off"
                    >
                    </b-form-input>
                </b-form-group>

                <b-form-row class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'address'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-orders-sales-orders-edit-shipping',
                shippingAddress: [],
                submitting: 0
			}
		},

		methods: {
            updateAddress() {
                this.$emit('updateAddress', 'shipping', this.shippingAddress)
                this.closeModal(this.modalName)
            }
		},

		computed: {

		},

		mounted() {
            this.shippingAddress = Object.assign({}, this.address)
		}
	}
</script>
<style lang="scss">
    #modal-sales-orders-edit-shipping {
        .modal-content {
            .button-row {
                margin-top: 15px;
            }
        }
    }
</style>
